import React from 'react';
import { motion } from 'framer-motion';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import { useTheme, alpha } from '@mui/material/styles';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { textGradient } from '../../../../theme/mixins';
import { varAlpha } from '../../../../theme/palette';
import { varFade } from '../../../../theme/variants';

const FinalCTA = () => {
  const theme = useTheme();

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 10, md: 15 },
        bgcolor: theme.palette.grey[100],
        position: 'relative',
        textAlign: 'center',
      }}
    >
      <Container maxWidth="md">
        {/* Headline */}
        <Box
          component={motion.div}
          variants={varFade().inUp}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true, amount: 0.3 }}
          sx={{ mb: 3 }}
        >
          <Typography
            variant="h2"
            sx={{
              fontWeight: 800,
              fontSize: { xs: '32px', md: '48px' },
              color: theme.palette.grey[900],
              lineHeight: 1.2,
              mb: 2,
            }}
          >
            Ready to accelerate your{' '}
            <Box
              component="span"
              sx={{
                ...textGradient(`120deg, ${theme.palette.primary.main} 0%, ${theme.palette.info.main} 100%`),
              }}
            >
              hardware development?
            </Box>
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: theme.palette.grey[600],
              fontWeight: 400,
              fontSize: { xs: '16px', md: '18px' },
              maxWidth: 500,
              mx: 'auto',
            }}
          >
            Join teams already building faster with Partix
          </Typography>
        </Box>

        {/* CTA Buttons */}
        <Box
          component={motion.div}
          variants={varFade().inUp}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true, amount: 0.3 }}
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            justifyContent="center"
            sx={{ mb: 4 }}
          >
            {/* Primary CTA */}
            <Button
              variant="contained"
              size="large"
              endIcon={<ArrowForwardIcon />}
              href="/trialsignup"
              sx={{
                fontSize: '16px',
                px: 4,
                py: 1.75,
                borderRadius: '8px',
                boxShadow: theme.customShadows.primary,
                '&:hover': {
                  boxShadow: `0 12px 24px ${alpha(theme.palette.primary.main, 0.32)}`,
                  transform: 'translateY(-2px)',
                },
                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
              }}
            >
              Start Free Trial
            </Button>

            {/* Secondary CTA */}
            <Button
              variant="outlined"
              size="large"
              href="/contactus"
              sx={{
                fontSize: '16px',
                px: 4,
                py: 1.75,
                borderRadius: '8px',
                borderWidth: '2px',
                '&:hover': {
                  borderWidth: '2px',
                  bgcolor: varAlpha(theme.palette.primary.mainChannel, 0.08),
                  transform: 'translateY(-2px)',
                },
                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
              }}
            >
              Schedule Demo
            </Button>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default FinalCTA;
